import {
  FormLabel,
  Icon,
  Input,
  InputGroup,
  Text,
  InputLeftElement,
  VStack,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { useRef } from "react";
import { Trans } from "react-i18next";
import { BiFile } from "react-icons/bi";
import { FormInputProps } from "./type";
import { Wrapper } from "./Wrapper";

const FileUpload = ({
  name,
  label,
  type,
  errors,
  placeholder,
  onChange,
  value,
  options,
  disabled = false,
  register,
  watch,
  required,
  accept,
}: FormInputProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { ref, ...rest } = register(name);
  const styles = useMultiStyleConfig("Button", { variant: "outline" });

  const handleClick = () => inputRef.current?.click();

  return (
    <Wrapper name={name} error={errors[name]}>
      {label && (
        <FormLabel htmlFor={name} mb="1" fontSize="xs" display="inline-flex">
          {" "}
          <Trans>label</Trans>
          {required && (
            <Text px="1" color="red.500">
              <Trans>(required)</Trans>
            </Text>
          )}
        </FormLabel>
      )}
      <InputGroup onClick={handleClick}>
        <VStack align="flex-start">
          <Text variant="muted" fontSize="sm">
            <Trans>Max upload size is 10MB</Trans>
          </Text>
          <Input
            type="file"
            {...rest}
            style={{ border: "unset", padding: 0 }}
            sx={{
              "::file-selector-button": {
                border: "none",
                outline: "none",
                mr: 2,
                ...styles,
              },
            }}
            accept={accept as string}
            ref={ref}
          />
        </VStack>
      </InputGroup>
    </Wrapper>
  );
  return (
    <Wrapper name={name} error={errors[name]}>
      {label && (
        <FormLabel htmlFor={name} mb="1" fontSize="xs" display="inline-flex">
          {" "}
          <Trans>label</Trans>
          {required && (
            <Text px="1" color="red.500">
              <Trans>(required)</Trans>
            </Text>
          )}
        </FormLabel>
      )}
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <Icon as={BiFile} />
        </InputLeftElement>
        {/* <input
          type="file"
          multiple
          // onChange={(e) => {
          //   if (!e.currentTarget.files) return;
          //   formikUpdateSignature
          //     .setFieldValue("signature", e?.currentTarget?.files[0])
          //     .then((evt) => console.log(evt))
          //     .catch((err) => console.log(err));
          // }}
          accept="image/*"
          name="signature"
          ref={ref as unknown as LegacyRef<HTMLInputElement>}
          style={{ display: "none" }}
        /> */}
        <Input
          width="auto"
          id={name}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          type={type}
          {...register(name)}
          borderRadius="md"
          borderWidth="2px"
          borderColor="gray.200"
          multiple
          // onClick={(): void => {
          //   if (!ref || !ref?.current) return;
          //   // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          //   ref?.current?.click();
          // }}
        />
      </InputGroup>
    </Wrapper>
  );
};

export default FileUpload;
